import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isShowLoadingScreen : false,
    isShowJourney : false,
    isShowShareMenu : false,
    isShowMainMenu : false,
   	isShowMainMenuButton : false,
    isShowFinalScreen : false,
    isMuted : false,
    isLoadVideoFinish : false,
    //
    replayJourneyEvent : false,
    igURL : "https://www.instagram.com/ar/669259440366339/",
    exhibitionURL : "https://www.hongkongdisneyland.com/",
    exhibitionURLPath : "building-a-dream/?CMP=Cpn15An20Hkh5buildadm",
    ticketingURL : "https://www.hongkongdisneyland.com/",
    ticketingURLPath : "offers-discounts/double-celebration/?CMP=Cpn15An20Hkh5DbCele",
  },
  element:{
    audioElement : null,
  }
})




// WEBPACK FOOTER //
// ./src/store.js